// extracted by mini-css-extract-plugin
module.exports = {"modal":"ViewInvoiceModal_modal__21H-q","actions":"ViewInvoiceModal_actions__2Rs40","pdfViewer":"ViewInvoiceModal_pdfViewer__34B_c"};